
import "@fortawesome/fontawesome-pro/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import counsellorElement from "./custom/counsellorelement";
import counsellorPage from "./custom/counsellor";
import onboardingProcess from "./custom/onboarding";
import referralForm from "./custom/referral";
import profileForm from "./custom/profile";
import carouselAnimation from "./custom/carouselanimation";
import {initSidebarMenu} from "./header/sidebarNav";

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import animations from "./custom/animations";
import announcementBar from "./header/announcementbar";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother,ScrollToPlugin);


$(function () {

    counsellorPage();
    onboardingProcess();
    referralForm();
    profileForm();
    carouselAnimation();
    initSidebarMenu();
    animations();
    announcementBar();
    counsellorElement();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $(".scroll-down").click(function() {
        $('html, body').animate({
            scrollTop: $("#homeContent").offset().top
        }, 500);
    });

    // Initial smoother setup with a media query
    let smoother;
    function initSmoother() {
        if (smoother) smoother.kill(); // Clean up if there's an existing instance

        // Use matchMedia to conditionally initialize
        if (window.matchMedia("(min-width: 991px)").matches && $('.login-page').length < 1) {
            smoother = ScrollSmoother.create({
                smooth: 1.1,
                effects: true
            });
        }
    }

    // Initialize on page load
    initSmoother();
    // Update on resize
    window.addEventListener("resize", initSmoother);
    window.onload = () => {
        if (window.location.hash) {
            gsap.to(window, { duration: 1, scrollTo: window.location.hash });
        }
    };
});


